export enum CalendarViewType {
    Year = 'Year',
    Month = 'Month',
    Day = 'Day',
    Multi = 'Multi'
}
